import { HttpClient, HttpEventType, HttpHeaders, HttpRequest } from "@angular/common/http";
// import * as qs from "qs";
import { Observable, catchError, map, throwError } from "rxjs";
// import { FikoYTEnvIstemci } from "src/app/Environment/environment";
import { Injectable } from "@angular/core";
import { IStringifyOptions } from "qs";
import { FikoYTEnvIstemci } from "./Environment/environment";
import { CihazKimlikService } from "./fikoyt.cihaz-kimlik.service";
// import { ObjectID } from 'mongodb'; // or ObjectID


// export const FikoYTQsDecoder = function FikoYTQsDecoder(parseNumbers = true, parseBool = true, ignoreNull = true, ignoreEmptyString = true) {
//     return function decoder(str: any, decoder: any, charset: any) {
//         const strWithoutPlus = str.replace(/\+/g, ' ')
//         if (charset === 'iso-8859-1') {
//             // unescape never throws, no try...catch needed:
//             return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape)
//         }

//         if (/^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(str)) {
//             return ObjectId.createFromHexString(str)
//         }

//         if (/(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/.test(str)) {
//             return new Date(str)
//         }


//         if (parseNumbers && /^-?[0-9]\d*(\.\d+)?$/.test(str)) {
//             return parseFloat(str)
//         }

//         if (ignoreEmptyString && str.length === 0) {
//             return
//         }

//         const keywords: any = {
//             null: ignoreNull ? undefined : null,
//             undefined
//         }

//         if (str in keywords) {
//             return keywords[str]
//         }

//         const boolKeywords: any = {
//             true: true,
//             false: false
//         }

//         if (parseBool && str in boolKeywords) {
//             return boolKeywords[str]
//         }

//         try {
//             return decodeURIComponent(strWithoutPlus)
//         } catch (e) {
//             return strWithoutPlus
//         }
//     }
// }

// export const FikoYTQsParserOptions: IParseOptions = {
//     decoder: FikoYTQsDecoder(),
//     charset: "utf-8",
//     charsetSentinel: true, strictNullHandling: true,
//     comma: true, parseArrays: true, allowDots: false, allowPrototypes: true, depth: 30, arrayLimit: 30
// }

export const FikoYTQsStringifyOptions: IStringifyOptions = {
    charset: "utf-8",
    charsetSentinel: true,
    skipNulls: false, strictNullHandling: true,
}

/** BİLGİ: Http İsteklerinin Türkçeleştirilmiş Hali */
export enum IstekOlayTuru {
    Istendi = 0,
    IlerlemeIstek = 1,
    BaslikCevap = 2,
    IlerlemeCevap = 3,
    Cevaplandi = 4,
    Ozel = 5
}

/** BİLGİ: Python(Server) Fiko Hata Sınıfını Buraya Taşıdım */
export interface FikoHata {
    kategori: string;
    kod: number;
    baslik: string;
    mesaj: string;
    sistemMesaji: string;
}

export interface IstekIlerleme {
    toplam: number;
    durum: number;
    yuzde: number;
}

type DurumHatalarTipi = Array<FikoHata>;

export interface IstekDurum {
    hata?: boolean | null;
    hatalar?: DurumHatalarTipi;
}

/** BİLGİ: Şimdilik Bir İşe Yaramıyor Ama Lazım Olur Diye Silmiyorum */
export interface IstekGiden {
    ismi: string;
    parametreler?: Array<any>;
    form?: any;
    kwargs?: any;
    json?: any;
}
/** NOT: Sonuc İstekleri Standarda Bağlanıyor */
export default interface IstekSonuc<T> {
    turu?: IstekOlayTuru;
    ilerleme?: IstekIlerleme;
    durum?: IstekDurum;
    istek?: IstekGiden;
    sonuc?: T | any;
}

@Injectable({
    providedIn: 'root'
})
export class FikoYTIstekService {


    constructor(
        public readonly http: HttpClient,
        public readonly Cihaz: CihazKimlikService,
    ) {

    }

    public fapisteV1<T>(metod: "POST" | "GET" | "PATCH" | "PUT" | "DELETE" | "OPTIONS" = "GET", istek: string, { sorguParametreler = null, vucutParametreler = null, onEkOlsun = true }: { sorguParametreler?: any, vucutParametreler?: any | null, onEkOlsun?: boolean | null } = { sorguParametreler: {}, vucutParametreler: null, onEkOlsun: true }): IstekSonuc<T> & Observable<IstekSonuc<T>> | any {
        // public fapisteV1<T>(metod: "POST" | "GET" | "PATCH" | "PUT" | "DELETE" | "OPTIONS" = "GET", istek: string, sorguParametreler: any, vucutParametreler: any | null): IstekSonuc<T> & Observable<IstekSonuc<T>> | any {
        let istem: string;
        if (onEkOlsun) istem = FikoYTEnvIstemci.adres.url + ":" + FikoYTEnvIstemci.adres.fapiPort + '/fapiv1/' + `${FikoYTEnvIstemci.uygulamaIsmi}.` + istek
        else
            istem = FikoYTEnvIstemci.adres.url + ":" + FikoYTEnvIstemci.adres.fapiPort + '' + istek
        const req = new HttpRequest(metod, istem, vucutParametreler, {
            /** BİLGİ: İlerleme Durumu Hakkında Rapor Almak İçin */
            reportProgress: true,
            /** BİLGİ: Response Headerleri */
            headers: new HttpHeaders(
                {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Credentials": "true",
                    "mode": 'no-cors',
                    "uygulama": FikoYTEnvIstemci.uygulamaIsmi,
                    "cihaz_kimlik": this.Cihaz.kimlik,
                    "cihaz_tipi": this.Cihaz?.bilgiler?.deviceType ?? "Web",
                    // @ts-ignore
                    // "cihaz_bilgi": this.Cihaz.bilgiler.toJson(),
                }),
            /** BİLGİ: 
             * Session Ve Cookie Yani Request Bilgileri İle İletim Yapmak İçin 
             * Giriş Kontrolü Ve Aktif Kullanıcı İçin Gerekli (Flask.current_user)
             */
            withCredentials: true
        });

        return this.http.request(req).pipe(
            /**  BİLGİ: 
             * Gelen Veri Haritalanıyor.Aşağıdaki Olaylar Ana Hattır.
             * Çağırılan Fonksiyon İçinde Tekrardan Haritalanarak Süzülebilir.
             */
            map(sonuc => {
                let _snc: IstekSonuc<T> | Observable<IstekSonuc<T>> | any = {};
                //  console.log(sonuc);
                /** BİLGİ: Eğer Olay Türü Cevap Alınıyor İse */
                if (sonuc.type === HttpEventType.DownloadProgress) {
                    // console.log("ilerlemeCevap", sonuc)
                    _snc.turu = IstekOlayTuru.IlerlemeCevap;
                    _snc.ilerleme = { durum: 0, toplam: 0, yuzde: 0 };
                    _snc.ilerleme.toplam = sonuc.total;
                    _snc.ilerleme.durum = sonuc.loaded;
                    _snc.ilerleme.yuzde = (sonuc.loaded / sonuc.total!) * 100;
                    // return _snc
                }
                /** BİLGİ: Eğer Olay Türü İstek Yollanıyor İse */
                if (sonuc.type === HttpEventType.UploadProgress) {
                    // console.log("ilerlemeİstek", sonuc)
                    _snc.turu = IstekOlayTuru.IlerlemeIstek;
                    _snc.ilerleme = { durum: 0, toplam: 0, yuzde: 0 };
                    _snc.ilerleme.toplam = sonuc.total;
                    _snc.ilerleme.durum = sonuc.loaded;
                    _snc.ilerleme.yuzde = (sonuc.loaded / sonuc.total!) * 100;
                    // return _snc
                }
                /** BİLGİ: Eğer Olay Türü İstek Cevaplandi İse */
                if (sonuc.type === HttpEventType.Response) {
                    // console.log("Cevaplandı", sonuc)
                    /** YAP: Eğer Serverda Durum Hatalı Dönmüş İse Observable Hatalı Döndürülecek */
                    _snc.turu = IstekOlayTuru.Cevaplandi;
                    _snc.ilerleme = { durum: 0, toplam: 100, yuzde: 100 };
                    _snc.sonuc = sonuc;
                    // return _snc
                }
                /** BİLGİ: Eğer Olay Türü Cevap İstek Başlığı İse */
                if (sonuc.type === HttpEventType.ResponseHeader) {
                    // console.log("BaslikCevap", sonuc)
                    _snc.turu = IstekOlayTuru.BaslikCevap;
                    _snc.ilerleme = { durum: 0, toplam: 100, yuzde: 100 };
                    _snc.sonuc = sonuc;
                    // return _snc
                }
                /** BİLGİ: Eğer Olay Türü İstek Gonderildi İse */
                if (sonuc.type === HttpEventType.Sent) {
                    // console.log("istendi", sonuc)
                    _snc.turu = IstekOlayTuru.Istendi;
                    _snc.ilerleme = { durum: 0, toplam: 100, yuzde: 100 };
                    _snc.sonuc = sonuc;
                    // return _snc
                }
                /** BİLGİ: Eğer Olay Türü İstek Özel İse */
                if (sonuc.type === HttpEventType.User) {
                    _snc.turu = IstekOlayTuru.Ozel;
                    _snc.ilerleme = { durum: 0, toplam: 0, yuzde: 100 };
                    _snc.sonuc = sonuc;
                    // return _snc
                }
                return _snc;
            }),
            /** BİLGİ: İstekte Ve İsteğin Cevabında Hata Var İse  */
            catchError(hatalar => throwError(hatalar))
        );
    }

}
